import {
  useSelectedNumberByVariableKey,
  useSelectedValueByVariableKey,
  useVariableByKey,
} from '@k3/core';
import { useShopName } from './useShopName';

export type LabelAndValue = { variable: string; value: string };
export type LabelAndValues = { variable: string; value: string | string[] };

export const useLabelAndValue = (key: string): LabelAndValue => {
  const variable = useVariableByKey(key);
  const value = useSelectedValueByVariableKey(key);
  return { variable: variable?.label ?? '', value: value?.label ?? '' };
};

export const useNumberLabelAndNumber = (key: string): LabelAndValue => {
  const variable = useVariableByKey(key);
  const value = useSelectedNumberByVariableKey(key);
  return {
    variable: variable?.label ?? '',
    value: `${value ?? 0} ${variable?.settings.templateOptions.unit}`,
  };
};
export const useHeight = (): LabelAndValue => {
  const shopModel = useShopName();

  const pureHeight = useNumberLabelAndNumber('height');
  return {
    ...pureHeight,
    value: ['Flextisch', 'Flexecktisch'].includes(shopModel)
      ? '71 - 121 cm'
      : pureHeight.value,
  };
};
